import { createContext, useContext } from 'react';
import { CalendarType } from '../../../models';
import { DateUtils } from '../../../utils';

export const FaresCalendarContext = createContext({
    type: CalendarType.DEPARTURE,
    minMonthSeen: DateUtils.getToday(),
    maxMonthSeen: DateUtils.addMonths(DateUtils.getToday(), 1),
});

export const useFaresCalendarContext = () => useContext(FaresCalendarContext);

export const FaresOnLoadContext = createContext({
    isLastFareLoaded: false,
    setLastFareLoaded: () => {},
    lastDate: DateUtils.getToday(),
});

export const useFaresOnLoadContext = () => useContext(FaresOnLoadContext);
